import { useDispatch } from "react-redux";
import { userHintsSlice } from "../../userHintsReducer";
import useEffectOnce from "../../../../hooks/useEffectOnce";

function useHintsInit() {
    const dispatch = useDispatch();

    useEffectOnce(() => {
        dispatch(userHintsSlice.actions.initUserHintsAction());
    });
}

export default useHintsInit;
